import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'infra-load_animation_frames-view';

/**
 * Tracks the length of animation frames during page load.
 */
export function trackInfraLoadAnimationFramesView(
  FrameTimings: string,
  TotalWindowLength2: string,
  Status3: string = '',
  Name4: string = '',
  LoadType5: string = '',
  Status6: string = ''
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: {
      FrameTimings,
      TotalWindowLength2,
      Status3,
      Name4,
      LoadType5,
      Status6,
    },
  });
}
